<template>
  <div id="app">
    <div v-if="liad_show">
      <load></load>
    </div>
  <div class="maincon">
    <div>
      <el-select v-model="companyee_choiced"  multiple filterable placeholder="请选择" style="float: left;">
        <el-option
          v-for="item in companyee_list.list"
          :key="item.num"
          :label="item.name"
          :value="item.num">
        </el-option>
		<!-- <el-pagination small style="margin-top: 1rem;" @size-change="companyee_handleSizeChange" @current-change="companyee_handleCurrentChange"
		  :current-page="companyee_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="companyee_list.per_page"
		  layout="total, sizes, prev, pager, next, jumper" :total="companyee_list.total">
		</el-pagination> -->
      </el-select>
      <el-date-picker
        v-model="time"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" @click="study_change()">检索</el-button>
      <el-button type="primary" @click="study_load_excel()">整体导出</el-button>
    </div>
    <div>
    <el-table stripe :data="study_list.data" style="width: 100%;margin-top: 20px;" :row-style="{height:'70px'}">
      <el-table-column label="编号" prop="num" width="" sortable>
      </el-table-column>
      <el-table-column label="姓名" prop="rale_name" width="" sortable>
      </el-table-column>
      <el-table-column label="类型" width="" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.train=='0'">自学</span>
          <span v-else>任务</span>
        </template>
      </el-table-column>
      <el-table-column label="视频库" width="" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.type=='0'">药知课程</span>
          <span v-else="scope.row.type=='1'">内部课程</span>
          <span v-else>直播课程</span>
        </template>
      </el-table-column>
      <el-table-column label="视频" prop="video" width="" sortable>
      </el-table-column>
      <el-table-column label="进度" width="" sortable>
        <template slot-scope="scope">
          <el-progress :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="时长" prop="total" width="" sortable>
      </el-table-column>
      <el-table-column align="right" width="150" label="日期">
        <template slot-scope="scope">
          <span>{{scope.row.study_time}}</span>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="study_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="study_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="study_list.total">
      </el-pagination>
    </div>

  </div>
  </div>
</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        liad_show:false,
        // companyee_list:{},
        study_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
          time:'_',
          companyee:'',
        },
		companyee_list:{
		  list:'',
		},
        companyee_choiced:[],
        time:null,
        search: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    components: {
       load:load
    },
    mounted() {
      this.get_companyee()
    },
    methods: {
      study_load_excel(){
        let _this=this
        _this.liad_show=true
        var data={}
        if(_this.time==null){
          data.time='_'
        }else{
          data.time=_this.time[0]+"_"+_this.time[1]
        }
        data.companyee=_this.companyee_choiced.toString()
        _this.axios.post('/v2/c_census/study_load_excel',{data:data},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '员工学习记录详情.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
             _this.liad_show=false
          }else{
            _this.$message.error('服务器内部错误')
            _this.liad_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.liad_show=false
        });
      },
      study_change(){
        let _this=this
        _this.load=true
        if(_this.time==null){
          _this.study_time='_'
        }else{
          _this.study_time=_this.time[0]+"_"+_this.time[1]
        }
        _this.study_list.companyee=_this.companyee_choiced.toString()
        _this.study_list.current_page=1
        _this.study_list.total=0
        _this.study_list.per_page=10
        _this.get_study()
        _this.load=false

      },

      get_companyee(){
        let _this=this
        _this.liad_show=true
        _this.axios.get("/v2/c_companyee/get_list",{params:{'page':1,'limit':999999,}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.companyee_list.list=res.data.data.list
              // _this.companyee_list.total=res.data.data.total
               _this.get_study()
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },

      get_study(){
        let _this=this
        _this.axios.get("/v2/c_census/get_study_history",{params:{'page':_this.study_list.current_page,'limit':_this.study_list.per_page,'time':_this.study_list.time,'companyee':_this.study_list.companyee}}).then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
                _this.study_list=res.data.data
                _this.study_list.per_page=parseInt(_this.study_list.per_page)
                _this.liad_show=false
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },

      handleSizeChange(val) {
        this.study_list.current_page = 1
        this.study_list.per_page = val
        this.get_study()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.study_list.current_page = val
        _this.get_study()
      },

	  companyee_handleSizeChange(val) {
	    this.companyee_list.current_page = 1
	    this.companyee_list.per_page = val
	    this.get_companyee()
	  },

	  companyee_handleCurrentChange(val) {
	    let _this=this
	    _this.companyee_list.current_page = val
	    this.get_companyee()
	  },
    },
  }
</script>

<style scoped>
  #app{
   padding: 20px;
   background-color: white;
   height: 100%;
   padding-bottom: 5%;
  }
  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/census/study/study.vue